module.exports = __webpack_public_path__ + "static/media/pillir-ico.1d319c9d.svg";